import {timeFormat, entityToString, entityToStringForObj} from '@/common/filter';
import '@/assets/iconfont/iconfont.css'
import './assets/styles/layout/layout.less' // 引入布局样式
import './assets/styles/cover/cover.less' // 覆盖样式
import './assets/styles/base/base.less'
import './assets/css/deviceMap.css'
import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import 'leaflet.icon.glyph';
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
import "./styles/myCss.css"

import { createApp } from 'vue'
import App from "./App.vue";
import router from './router/index'
import i18n from './i18n';
import ViewUIPlus from 'view-ui-plus';
// iview样式
import 'view-ui-plus/dist/styles/viewuiplus.css'
import 'element-plus/es/components/message/style/css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "element-plus/es/components/loading/style/index";
import store from './store'
import Clipboard from 'v-clipboard'
import  "./common/utils/MarkerClusterer_min"

let winWidth = document.documentElement.clientWidth
if (winWidth <= 600) {
  store.commit('CLOSE_SLIDEBAR')
} else {
  store.commit('OPEN_SLIDEBAR')
}
window.onresize = function () {
  winWidth = document.documentElement.clientWidth
  if (winWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  } else {
    store.commit('OPEN_SLIDEBAR')
  }
}

const app = createApp(App)
  .use(router)
  .use(i18n)
  .use(Clipboard)
  .use(ViewUIPlus, {
    i18n
  })
  .use(ElementPlus)
  .use(store);
// 全局属性
app.config.globalProperties.$filters = {
  timeFormatFilter(strValue) {
    if (typeof strValue === 'number') {
      return timeFormat(strValue);
    }
    return strValue;
  },
  objectPropertiesConversionFilter(obj) {
    entityToStringForObj(obj)
  }
}

app.mount('#app')

